// extracted by mini-css-extract-plugin
module.exports = {"title":"simple-dialog_title__2yKTM","titleText":"simple-dialog_titleText__2vDtd","error":"simple-dialog_error__2PQp-","message":"simple-dialog_message__1Lbka"};